





















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { ShareLink } from '@/types/api/share'
import { timeFromNow, timeFormat } from '@/util/Time'
import { RootState } from '@/store/types'
import { UserWithKey } from '@/types/user'
import PCrypto from '@/util/crypto/PCrypto'
import { EditorEntry } from '@/store/editor/types'
import { baseUrl } from '@/util/Helpers'
import { Maybe } from '@/types/general'

@Component({ name: 'share-link-item' })
export default class ShareLinkItem extends Vue {
    @Prop({ type: Object, required: true })
    link!: ShareLink

    @Prop({ type: Boolean, default: false })
    activeLink!: boolean

    @State((state: RootState) => state.share.peers)
    peers!: UserWithKey[]

    @State((state: RootState) => state.editor.entry)
    entry!: EditorEntry

    get derivedLink(): string {
        const { linkId } = this.link
        return `${baseUrl()}#/share/${linkId}/${PCrypto.PBK(linkId, this.entry.documentKey!)}`
    }

    get user(): Maybe<UserWithKey> {
        return this.peers.find(peer => peer.id === this.link.sharedBy)
    }

    get username(): string {
        return this.user ? this.user.name : 'Some user'
    }

    get email(): string {
        return this.user ? this.user.email : ''
    }

    get viewedAt() {
        return timeFormat(this.link.updatedAt)
    }

    get createdAt() {
        return timeFormat(this.link.createdAt)
    }

    /**
     * Get the time from now (moment)
     */
    timeFromNow(time: string) {
        return timeFromNow(time)
    }
}
